'use client';

import { exposeClassnames as classnames } from '@stadionhq-v3/utilities';
import {
  ScrollerBlockProps,
  ScrollerBlock as V3ScrollerBlock,
} from '@stadionhq-v3/base-ui';
import { QA_SCROLLER_BLOCK } from '@test-config/testIds';
import styles from './scrollerBlock.module.scss';

export const ScrollerBlock = ({
  classNames,
  testId = QA_SCROLLER_BLOCK.COMPONENT,
  ...props
}: ScrollerBlockProps) => {
  const classes = classnames([styles.tokens, styles.scrollerBlock], classNames);

  return <V3ScrollerBlock classNames={[classes]} testId={testId} {...props} />;
};
